import { component } from "picoapp";

export default component((node) => {
  const url = new URL(window.location);
  if (url.hash === "#faq-shipping") {
    const faqShipping = node.querySelector(
      "#i-ordered-something-on-preorder-when-will-it-ship"
    );
    const faqDetails = node.querySelector(
      "#i-ordered-something-on-preorder-when-will-it-ship > .animated-details"
    );
    faqShipping.scrollIntoView();
    faqDetails.setAttribute("open", "true");
  }
});
